import { CheckCircleRounded } from "@mui/icons-material";
import { Avatar, Badge, Card, CardContent, Rating, styled, Typography } from "@mui/material";
import { Box, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { tokens } from "../../../store/tokens";
import "./FreelancerItem.css";

const truncate = (str, len) => (str && str.length > len ? str.slice(0, len) + "…" : str);

const StyledBadge = styled(Badge)(() => ({
  "& .MuiBadge-badge": {
    backgroundColor: tokens.color.success,
    color: tokens.color.success,
    boxShadow: `0 0 0 2px ${tokens.color.white}`,
  },
}));

const FreelancerItem = (props) => {
  const navigate = useNavigate();
  const { freelancerData } = props;
  const {
    category,
    active_state,
    name,
    slogan,
    pic,
    sopnoId,
    sub_category,
    sub_category_info,
    category_info,
    user_rate,
    user_state,
    user_skill,
    agency_info,
    poster_info,
  } = freelancerData;

  const isActive = active_state?.[0]?.state === 1;
  const isVerified = user_state?.[0]?.states === 1;
  const averageRating = user_rate?.average_rating ?? 0;
  const totalReviews = user_rate?.total_review ?? 0;



  const displayName =
    truncate(agency_info?.cname, 20) ?? truncate(poster_info?.Name, 20) ?? name;

  const displaySubtitle =
    slogan ||
    user_skill?.[0]?.tag ||
    (category_info?.[0]?.title
      ? [category_info[0].title, sub_category_info?.[0]?.title].filter(Boolean).join(", ")
      : [category, sub_category].filter(Boolean).join(", "));

  const avatarSrc =
    pic ||
    (poster_info?.user_pic?.[0] && "//yeapbe.com/" + poster_info.user_pic[0].pic_url) ||
    (agency_info?.agency_logo?.[0] && "//yeapbe.com/" + agency_info.agency_logo[0].pic_url) ||
    "//aps.songjukti.com/image/web_admin/data_entry.jpg";

  return (
    <Card
      onClick={() => navigate("/" + sopnoId)}
      sx={{
        cursor: "pointer",
        borderRadius: `${tokens.radius.lg}px`,
        border: `1px solid ${tokens.color.line}`,
        overflow: "hidden",
        transition: "box-shadow 0.25s ease, transform 0.25s ease",
        "&:hover": {
          boxShadow: tokens.shadow.md,
          transform: "translateY(-3px)",
        },
      }}
    >
      <Box
        sx={{
          background: `linear-gradient(to right, ${tokens.color.teal}, ${tokens.color.tealDark})`,
          height: 72,
        }}
      />

      <CardContent sx={{ mt: "-48px", pb: 2.5 }}>
        <Stack spacing={2} justifyContent="left" alignItems="center">
          <StyledBadge overlap="circular" variant="dot" color={isActive ? "success" : "default"}>
            <Avatar
              src={avatarSrc}
              alt={poster_info?.Name ?? name ?? "Freelancer"}
              sx={{ width: 80, height: 80, border: `4px solid ${tokens.color.white}` }}
            />
          </StyledBadge>

          <Stack spacing={2} justifyContent="center" alignItems="center">
            <Box>
              <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                <CheckCircleRounded
                  sx={{
                    fontSize: "1.05rem",
                    color: isVerified ? tokens.color.success : tokens.color.inkFaint,
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: tokens.font.heading,
                    textAlign: "center",
                    fontSize: "1rem",
                    fontWeight: 700,
                    color: tokens.textOn.light.primary,
                  }}
                >
                  {displayName}
                </Typography>
              </Stack>
              <Typography
                sx={{
                  fontFamily: tokens.font.body,
                  textAlign: "center",
                  fontSize: "0.85rem",
                  color: tokens.textOn.light.secondary,
                  mt: 0.25,
                }}
              >
                {displaySubtitle}
              </Typography>
            </Box>

            <Stack spacing={0.5} direction="row" justifyContent="center" alignItems="center">
              <Typography
                sx={{
                  fontFamily: tokens.font.body,
                  fontSize: { xs: "0.7rem", md: "0.8rem" },
                  fontWeight: 700,
                  color: tokens.color.ink,
                  bgcolor: tokens.color.warningBg,
                  px: 0.75,
                  py: 0.25,
                  borderRadius: `${tokens.radius.sm}px`,
                }}
              >
                {averageRating}
              </Typography>
              <Rating name="read-only" value={averageRating ?? 0} readOnly precision={0.5} sx={{ fontSize: "1rem" }} />
              <Typography
                sx={{
                  fontFamily: tokens.font.body,
                  fontSize: { xs: "0.7rem", md: "0.8rem" },
                  fontWeight: 600,
                  color: tokens.textOn.light.secondary,
                }}
              >
                ({totalReviews  ?? 0} reviews)
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default FreelancerItem;